import type { PageContent } from '@barbeiropro/contracts';
import { Field } from '@/components/shared/field';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { ImageField } from './image-field';

type Seo = PageContent['seo'];

export function SeoTab({ seo, onChange }: { seo: Seo; onChange: (s: Seo) => void }) {
  const set = (patch: Partial<Seo>) => onChange({ ...seo, ...patch });
  return (
    <div className="grid gap-5">
      <p className="text-sm text-muted-foreground">Define como a página aparece no Google e quando alguém compartilha o link.</p>
      <Field id="seo-title" label="Título da página" hint={`${seo.title.length}/70 caracteres. Vazio usa o nome da barbearia.`}>
        <Input id="seo-title" maxLength={70} value={seo.title} onChange={(e) => set({ title: e.target.value })} />
      </Field>
      <Field id="seo-desc" label="Descrição" hint={`${seo.description.length}/160 caracteres. Resuma o que o cliente encontra aqui.`}>
        <Textarea id="seo-desc" rows={3} maxLength={160} value={seo.description} onChange={(e) => set({ description: e.target.value })} />
      </Field>
      <ImageField label="Imagem de compartilhamento" value={seo.ogImage} onChange={(v) => set({ ogImage: v ? { ...v, alt: v.alt ?? '' } : null })} />
      <p className="-mt-3 text-xs text-muted-foreground">Sem imagem aqui, usamos a foto do destaque da página.</p>
      <label className="flex items-start gap-2.5 text-sm">
        <input type="checkbox" className="mt-0.5 size-4 accent-[var(--bottle)]" checked={seo.noindex} onChange={(e) => set({ noindex: e.target.checked })} />
        <span>
          Esconder esta página dos buscadores
          <span className="block text-xs text-muted-foreground">Ela continua acessível por link, mas o Google não indexa.</span>
        </span>
      </label>
    </div>
  );
}
